module.exports = __webpack_public_path__ + "media/images/logo_white_with_padding-1f79efc8c2fd1fc5a43deceb555925ac.png";